var _ = require('lodash');
var Time = require('./time.js'); 
var Avatar = require('./Avatar.js');

function ConversationSummary(data, labels)
{
    this.data = _.cloneDeep(data);
    this.labels = labels;
    this.update();
}

ConversationSummary.prototype.update = function()
{
    this.label_line = this.getLabelLine(); // cache the label line: also useful for view updates...
}

ConversationSummary.prototype.getLabelLine = function()
{
    var label_line = "";
    var summary = this.data;

    for ( var i = 0; i < summary.all_conversation_endpoints_array.length; i++ )
    {
        let endpoint = summary.all_conversation_endpoints_array[i];
        if ( endpoint == summary.for_endpoint && summary.all_conversation_endpoints_array.length > 1  ) continue;

        if ( label_line.length != 0 )
            label_line += ', ';

        label_line += this.labels.getWithEndpointLabel(endpoint);
    }

    return label_line;
};

ConversationSummary.prototype.getLastMessageFromLabel = function()
{
    if ( this.data.last_message_from_employee_initials != null )
        return this.data.last_message_from_employee_initials;
        
    if ( this.data.for_endpoint === this.data.last_message_from )
        return "You";

    return this.labels.get(this.data.last_message_from);
};

ConversationSummary.prototype.getAvatarCount = function()
{
    return this.data.all_conversation_endpoints_array.length-1;
};

ConversationSummary.prototype.getAvatar = function(idx)
{
    for ( let i = 0; i < this.data.all_conversation_endpoints_array.length; i++ )
    {
        let endpoint = this.data.all_conversation_endpoints_array[i];
        if ( endpoint === this.data.for_endpoint && this.data.all_conversation_endpoints_array.length > 1 ) continue;

        if ( idx == 0 ) 
        return new Avatar(this.labels.get(endpoint), endpoint); 

        idx--;
    }

    return null;
};

ConversationSummary.prototype.getHumanReadableLastMessageAge = function(now)
{
    return Time.getHumanReadableAge(this.data.last_message_time, now);
}

ConversationSummary.prototype.getLastMessageLine = function(now)
{
    if ( this.data.all_conversation_endpoints_array.length == 2 && this.data.last_message_from != this.data.for_endpoint )
        return this.data.last_message_text;

    return this.getLastMessageFromLabel()+": "+this.data.last_message_text;
}



ConversationSummary.prototype.isSameConversation = function(other_summary)
{
    return this.data.conversation_id === other_summary.data.conversation_id &&
            this.data.for_endpoint === other_summary.data.for_endpoint;
}

ConversationSummary.prototype.getLastMessageTime = function()
{
    return this.data.last_message_time;
}

ConversationSummary.prototype.getLastMessageText = function()
{
    return this.data.last_message_text;
}

ConversationSummary.prototype.getConversationId = function()
{
    return this.data.conversation_id;
}

ConversationSummary.prototype.getRead = function()
{
    return this.data.read;
}

ConversationSummary.prototype.getArchived = function()
{
    return this.data.archived;
}

ConversationSummary.prototype.getForEndpoint = function()
{
    return this.data.for_endpoint;
}

ConversationSummary.prototype.getOtherEndpoints = function(endpoint)
{
    let ret = [];

    for ( let i = 0; i < this.data.all_conversation_endpoints_array.length; i++ )
    {
        if ( this.data.all_conversation_endpoints_array[i] === endpoint ) continue;

        ret.push(this.data.all_conversation_endpoints_array[i]);
    }

    return ret;
}

ConversationSummary.prototype.getLabelOfEndpoint = function(endpoint)
{
    return this.labels.get(endpoint);
}

module.exports = ConversationSummary;


